let firstImageClaimed = false;
let currentPageId = '';

/**
 * Claims priority for the first image on the page.
 * Returns `true` for the first caller (the LCP image), `false` for all subsequent callers.
 * Automatically resets when a new pageId is encountered.
 */
export const claimFirstImage = (pageId: string): boolean => {
    if (pageId !== currentPageId) {
        currentPageId = pageId;
        firstImageClaimed = false;
    }

    if (firstImageClaimed) {
        return false;
    }

    firstImageClaimed = true;

    return true;
};
